/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const CURRENT_USER_SELF_WITHDRAW = graphql(`
  mutation currentUserSelfWithdraw($registrantId: uuid!) {
    currentUserSelfWithdraw(registrantId: $registrantId) {
      delete_registrants_by_pk {
        _id
      }
    }
  }
`);
